(() => {
  if (customElements.get('ra-size-guide')) return;
  class RASizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const opts = {signal: this.controller.signal};
      this.trigger = this.querySelector('[data-ra-guide-open]');
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.addEventListener('click', e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault(); this.open(this.trigger);
      }, opts);
      this.querySelector('[data-ra-guide-close]').addEventListener('click', () => this.close(), opts);
      this.dialog.addEventListener('click', e => {
        const r = this.dialog.getBoundingClientRect();
        if (e.target === this.dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) this.close();
      }, opts);
      this.dialog.addEventListener('keydown', e => {
        if (e.key !== 'Tab') return;
        const nodes = [...this.dialog.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && el.getClientRects().length);
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
      }, opts);
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); }, opts);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); }, opts);
      // Existing description links use the same chart, but the explicit all-guides link does not.
      const scope = this.closest('product-info') || this.closest('section');
      scope?.addEventListener('click', e => {
        const link = e.target.closest('a[href]');
        if (!link || this.contains(link) || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        let url; try { url = new URL(link.href, location.href); } catch { return; }
        if (url.origin === location.origin && /\/pages\/(?:warhammer-)?size-guide(?:-\d{4})?\/?$/.test(url.pathname)) {
          e.preventDefault(); this.open(link);
        }
      }, opts);
    }
    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener;
      this.dialog.showModal();
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.querySelector('[data-ra-guide-close]').focus({preventScroll:true});
    }
    close() {
      this.dialog.close();
      this.restore();
    }
    restore() {
      if (this.locked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore();
      this.controller?.abort(); this.controller = null;
    }
  }
  customElements.define('ra-size-guide', RASizeGuide);
})();
